import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";

export const AdminImageUpload = ({ value, onChange, label = "Image", testId }) => {
  const [uploading, setUploading] = useState(false);
  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.url);
      toast.success("Uploaded");
    } catch (err) { toast.error("Upload failed"); } finally { setUploading(false); }
  };
  return (
    <div>
      <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-wider text-offwhite/55">{label}</label>
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="" className="h-28 w-40 rounded-lg border border-offwhite/15 object-cover" />
          <button type="button" onClick={() => onChange("")} className="absolute -right-2 -top-2 rounded-full bg-rose-600 p-1 text-white"><X className="h-3.5 w-3.5" /></button>
        </div>
      ) : (
        <label className="flex w-full max-w-xs cursor-pointer items-center gap-2 rounded-lg border border-dashed border-offwhite/25 bg-offwhite/5 px-4 py-6 font-body text-sm text-offwhite/55 hover:border-offwhite/50">
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {uploading ? "Uploading…" : "Upload image"}
          <input type="file" accept="image/*" className="hidden" onChange={handle} data-testid={testId} />
        </label>
      )}
    </div>
  );
};

export const Field = ({ label, children }) => (
  <div>
    <label className="mb-1.5 block font-mono text-[11px] uppercase tracking-wider text-offwhite/55">{label}</label>
    {children}
  </div>
);

export const inputCls = "w-full rounded-lg border border-offwhite/15 bg-[#0b130e] px-3 py-2.5 font-body text-sm text-offwhite outline-none focus:border-amber-brand/60";

export const Modal = ({ open, onClose, title, children, wide = false }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/60 p-4" onClick={onClose}>
      <div className={`my-8 w-full ${wide ? "max-w-3xl" : "max-w-xl"} rounded-2xl border border-offwhite/10 bg-[#101c14] p-6`} onClick={(e) => e.stopPropagation()}>
        <div className="mb-5 flex items-center justify-between">
          <h3 className="font-display text-lg font-bold text-offwhite">{title}</h3>
          <button onClick={onClose} className="rounded-full p-1 text-offwhite/50 hover:bg-offwhite/10"><X className="h-5 w-5" /></button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const Btn = ({ children, variant = "primary", className = "", ...props }) => {
  const styles = {
    primary: "bg-amber-brand text-espresso-dark hover:bg-amber-soft",
    outline: "border border-offwhite/20 text-offwhite hover:bg-offwhite/10",
    danger: "bg-rose-600 text-white hover:bg-rose-500",
    ghost: "text-offwhite/70 hover:bg-offwhite/10",
  };
  return <button className={`rounded-full px-5 py-2.5 font-display text-xs font-bold uppercase tracking-wider transition-all disabled:opacity-60 ${styles[variant]} ${className}`} {...props}>{children}</button>;
};

export const ConfirmDialog = ({ open, onClose, onConfirm, message }) => (
  <Modal open={open} onClose={onClose} title="Please Confirm">
    <p className="font-body text-sm text-offwhite/75">{message}</p>
    <div className="mt-6 flex justify-end gap-3">
      <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
      <Btn variant="danger" onClick={onConfirm} testid="confirm-delete">Confirm</Btn>
    </div>
  </Modal>
);
